/* ============================================================
   CULT MEMBER - theme.js (Shopify)
   1. Player audio (playlist emise par home-main.liquid)
   2. Cart drawer (AJAX Cart API Shopify)
   3. Horloge acceleree + ambiance jour/nuit
   ============================================================ */

'use strict';

document.addEventListener('DOMContentLoaded', () => {

  /* ============================================================
     1. PLAYER
     ============================================================ */

  const playlistEl = document.querySelector('[data-playlist]');
  const PLAYLIST = playlistEl ? JSON.parse(playlistEl.textContent) : [];

  const audio = document.getElementById('audio');
  const playBtn = document.getElementById('player-play');
  const prevBtn = document.getElementById('player-prev');
  const nextBtn = document.getElementById('player-next');
  const trackEl = document.getElementById('player-track');
  const timeEl = document.getElementById('player-time');
  const progressEl = document.getElementById('player-progress');
  const progressFill = document.getElementById('player-progress-fill');
  const volumeEl = document.getElementById('player-volume');
  const hasPlayer = audio && playBtn && PLAYLIST.length;

  const VOL_BLOCKS = 10;
  let currentTrack = 0;
  let volume = 7;

  function fmtTime(s) {
    if (!isFinite(s)) return '--:--';
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${String(sec).padStart(2, '0')}`;
  }

  function highlightTracklist() {
    document.querySelectorAll('#albums tr[data-track]').forEach(tr => {
      tr.classList.toggle('is-playing', Number(tr.dataset.track) === currentTrack);
    });
  }

  function loadTrack(i, autoplay) {
    currentTrack = (i + PLAYLIST.length) % PLAYLIST.length;
    audio.src = PLAYLIST[currentTrack].src;
    trackEl.textContent = PLAYLIST[currentTrack].title;
    highlightTracklist();
    if (autoplay) audio.play().catch(() => {});
  }

  function togglePlay() {
    if (audio.paused) {
      if (!audio.src) loadTrack(0, false);
      audio.play().catch(() => {});
    } else {
      audio.pause();
    }
  }

  function renderVolume() {
    volumeEl.innerHTML = '';
    for (let i = 0; i < VOL_BLOCKS; i++) {
      const b = document.createElement('span');
      b.className = 'vol-block' + (i < volume ? ' vol-block--on' : '');
      b.dataset.level = i + 1;
      volumeEl.appendChild(b);
    }
    volumeEl.setAttribute('aria-valuenow', volume);
    audio.volume = volume / VOL_BLOCKS;
  }

  if (hasPlayer) {
    playBtn.addEventListener('click', togglePlay);
    prevBtn.addEventListener('click', () => loadTrack(currentTrack - 1, !audio.paused));
    nextBtn.addEventListener('click', () => loadTrack(currentTrack + 1, !audio.paused));

    audio.addEventListener('play', () => { playBtn.innerHTML = '[&#10074;&#10074;]'; });
    audio.addEventListener('pause', () => { playBtn.innerHTML = '[&#9654;]'; });
    audio.addEventListener('ended', () => loadTrack(currentTrack + 1, true));

    audio.addEventListener('timeupdate', () => {
      const pct = audio.duration ? (audio.currentTime / audio.duration) * 100 : 0;
      progressFill.style.width = pct + '%';
      progressEl.setAttribute('aria-valuenow', Math.round(pct));
      timeEl.textContent = `${fmtTime(audio.currentTime)} / ${fmtTime(audio.duration)}`;
    });

    progressEl.addEventListener('click', (e) => {
      if (!audio.duration) return;
      const rect = progressEl.getBoundingClientRect();
      audio.currentTime = ((e.clientX - rect.left) / rect.width) * audio.duration;
    });

    volumeEl.addEventListener('click', (e) => {
      const block = e.target.closest('.vol-block');
      if (!block) return;
      volume = Number(block.dataset.level);
      renderVolume();
    });

    document.addEventListener('keydown', (e) => {
      if (e.code === 'Space' && document.activeElement === document.body) {
        e.preventDefault();
        togglePlay();
      }
    });

    progressEl.addEventListener('keydown', (e) => {
      if (!audio.duration) return;
      if (e.key === 'ArrowRight') audio.currentTime = Math.min(audio.currentTime + 5, audio.duration);
      if (e.key === 'ArrowLeft') audio.currentTime = Math.max(audio.currentTime - 5, 0);
    });

    volumeEl.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { volume = Math.min(volume + 1, VOL_BLOCKS); renderVolume(); }
      if (e.key === 'ArrowLeft')  { volume = Math.max(volume - 1, 0); renderVolume(); }
    });

    const albumsEl = document.getElementById('albums');
    if (albumsEl) {
      albumsEl.addEventListener('click', (e) => {
        const link = e.target.closest('a[data-play]');
        if (!link) return;
        e.preventDefault();
        const i = Number(link.dataset.play);
        if (i === currentTrack && !audio.paused) audio.pause();
        else loadTrack(i, true);
      });
    }

    renderVolume();
    loadTrack(0, false);
  }

  /* ============================================================
     2. CART DRAWER (AJAX Cart API)
     ============================================================ */

  const cartEl = document.getElementById('cart');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartItemsEl = document.getElementById('cart-items');
  const cartCountEl = document.getElementById('cart-count');
  const cartSubtotalEl = document.getElementById('cart-subtotal');

  function money(cents, currency) {
    return `$${(cents / 100).toFixed(2)} ${currency}`;
  }

  function openCart() {
    cartEl.classList.add('cart--open');
    cartEl.setAttribute('aria-hidden', 'false');
    cartOverlay.hidden = false;
  }

  function closeCart() {
    cartEl.classList.remove('cart--open');
    cartEl.setAttribute('aria-hidden', 'true');
    cartOverlay.hidden = true;
  }

  function renderCart(cart) {
    cartCountEl.textContent = cart.item_count;
    cartSubtotalEl.textContent = money(cart.items_subtotal_price, cart.currency);

    if (!cart.items.length) {
      cartItemsEl.innerHTML = '<li class="cart__empty">Your cart is empty.</li>';
      return;
    }

    cartItemsEl.innerHTML = cart.items.map(item => `
      <li class="cart-item" data-key="${item.key}">
        ${item.image ? `<img class="cart-item__img" src="${item.image}&width=120" alt="">` : '<span></span>'}
        <span>
          <span class="cart-item__title">${item.product_title}</span>
          <span class="cart-item__price">${money(item.final_line_price, cart.currency)}</span>
        </span>
        <span class="cart-item__qty">
          <button data-action="dec" aria-label="Decrease quantity">[-]</button>
          <span>${item.quantity}</span>
          <button data-action="inc" aria-label="Increase quantity">[+]</button>
          <button class="cart-item__remove" data-action="remove" aria-label="Remove">[remove]</button>
        </span>
      </li>
    `).join('');
  }

  async function refreshCart() {
    const cart = await fetch('/cart.js').then(r => r.json());
    renderCart(cart);
    return cart;
  }

  async function addToCart(variantId, quantity) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 }),
    });
    await refreshCart();
    openCart();
  }

  async function changeQuantity(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    await refreshCart();
  }

  /* ============================================================
     2b. MODAL PRODUIT
     Un clic sur une carte merch ([Add to cart] ou image) ouvre la
     modal : galerie de toutes les photos du produit (fleches +
     vignettes) puis bouton [Add to cart] qui ajoute au panier.
     ============================================================ */

  const pmodal = document.getElementById('pmodal');

  if (pmodal) {
    const pmImg = document.getElementById('pmodal-img');
    const pmThumbs = document.getElementById('pmodal-thumbs');
    const pmTitle = document.getElementById('pmodal-title');
    const pmPrice = document.getElementById('pmodal-price');
    const pmDesc = document.getElementById('pmodal-desc');
    const pmCart = document.getElementById('pmodal-cart');
    const pmPrev = document.getElementById('pmodal-prev');
    const pmNext = document.getElementById('pmodal-next');
    const pmQtyWrap = document.getElementById('pmodal-qty-wrap');
    const pmQtyVal = document.getElementById('pmodal-qty');

    let pmGallery = [];
    let pmIndex = 0;
    let pmVariant = null;
    let pmQty = 1;

    function pmSetQty(q) {
      pmQty = Math.min(99, Math.max(1, q));
      pmQtyVal.textContent = pmQty;
    }

    document.getElementById('pmodal-qty-dec').addEventListener('click', () => pmSetQty(pmQty - 1));
    document.getElementById('pmodal-qty-inc').addEventListener('click', () => pmSetQty(pmQty + 1));

    function pmSetImage(i) {
      if (!pmGallery.length) return;
      pmIndex = (i + pmGallery.length) % pmGallery.length;
      pmImg.src = pmGallery[pmIndex];
      pmThumbs.querySelectorAll('.pmodal__thumb').forEach((t, j) =>
        t.classList.toggle('is-active', j === pmIndex));
    }

    function pmOpen(id) {
      const node = document.querySelector(`script[data-product-json="${id}"]`);
      if (!node) return;
      const data = JSON.parse(node.textContent);

      pmTitle.textContent = data.title;
      pmPrice.textContent = data.price;
      pmDesc.textContent = data.desc;
      pmVariant = data.variant;
      pmCart.disabled = !data.available;
      pmCart.textContent = data.available ? '[Add to cart]' : 'Sold out';
      pmSetQty(1);
      pmQtyWrap.hidden = !data.available;

      pmGallery = data.images || [];
      pmThumbs.innerHTML = pmGallery.map((src, i) =>
        `<img class="pmodal__thumb" src="${src}" data-i="${i}" alt="" loading="lazy">`).join('');

      // fleches et vignettes seulement s'il y a plusieurs photos
      const single = pmGallery.length < 2;
      pmPrev.hidden = single;
      pmNext.hidden = single;
      pmThumbs.hidden = single;

      pmSetImage(0);
      pmodal.hidden = false;
      document.body.classList.add('pmodal-open');
    }

    function pmClose() {
      pmodal.hidden = true;
      document.body.classList.remove('pmodal-open');
    }

    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-product-open]');
      if (opener) {
        e.preventDefault();
        pmOpen(opener.dataset.productOpen);
        return;
      }
      if (e.target.closest('[data-pmodal-close]')) { pmClose(); return; }
      const thumb = e.target.closest('.pmodal__thumb');
      if (thumb) pmSetImage(Number(thumb.dataset.i));
    });

    pmPrev.addEventListener('click', () => pmSetImage(pmIndex - 1));
    pmNext.addEventListener('click', () => pmSetImage(pmIndex + 1));

    document.addEventListener('keydown', (e) => {
      if (pmodal.hidden) return;
      if (e.key === 'Escape') pmClose();
      if (e.key === 'ArrowLeft') pmSetImage(pmIndex - 1);
      if (e.key === 'ArrowRight') pmSetImage(pmIndex + 1);
    });

    pmCart.addEventListener('click', async () => {
      if (!pmVariant || pmCart.disabled) return;
      pmCart.textContent = 'Adding...';
      pmCart.disabled = true;
      try {
        await addToCart(pmVariant, pmQty); // ouvre le cart drawer
        pmClose();
      } finally {
        pmCart.textContent = '[Add to cart]';
        pmCart.disabled = false;
      }
    });
  }

  const cartOpen = document.getElementById('cart-open');
  if (cartOpen) {
    cartOpen.addEventListener('click', (e) => {
      e.preventDefault();
      refreshCart().then(openCart);
    });
  }

  document.getElementById('cart-close').addEventListener('click', closeCart);
  cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  cartItemsEl.addEventListener('click', (e) => {
    const btn = e.target.closest('button[data-action]');
    if (!btn) return;
    const li = btn.closest('.cart-item');
    const key = li.dataset.key;
    const qty = Number(li.querySelector('.cart-item__qty span').textContent);
    if (btn.dataset.action === 'inc') changeQuantity(key, qty + 1);
    if (btn.dataset.action === 'dec') changeQuantity(key, qty - 1);
    if (btn.dataset.action === 'remove') changeQuantity(key, 0);
  });

  refreshCart();

  /* ============================================================
     3. HORLOGE ACCELEREE + AMBIANCE JOUR/NUIT
     ============================================================ */

  const NIGHT_HOUR = 21;
  const BLEND_START = 18;
  const BLEND_END = 24;
  const FG_KEYS = ['--ink', '--blue', '--purple', '--muted'];

  const THEME_DAY = {
    '--blue': '#0000ee', '--purple': '#551a8b', '--ink': '#000000', '--bg': '#ffffff',
    '--gray': '#808080', '--muted': '#333333', '--th-bg': '#e8e8e8', '--row-line': '#dddddd',
  };
  const THEME_NIGHT = {
    '--blue': '#7a9fff', '--purple': '#c09aff', '--ink': '#e8e8e8', '--bg': '#0f0f0f',
    '--gray': '#6a6a6a', '--muted': '#aaaaaa', '--th-bg': '#1e1e1e', '--row-line': '#333333',
  };

  function smoothstep(t) { t = Math.max(0, Math.min(1, t)); return t * t * (3 - 2 * t); }
  function hexToRgb(h) { const n = parseInt(h.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function lerpColor(a, b, p) {
    const A = hexToRgb(a), B = hexToRgb(b), c = i => Math.round(A[i] + (B[i] - A[i]) * p);
    return `rgb(${c(0)}, ${c(1)}, ${c(2)})`;
  }

  function reorderAlbums(night) {
    const container = document.getElementById('albums');
    if (!container) return;
    const groups = Array.from(container.querySelectorAll('.album-group'));
    groups.sort((a, b) => {
      const d = Number(a.dataset.group) - Number(b.dataset.group);
      return night ? -d : d;
    });
    groups.forEach(g => container.appendChild(g));
  }

  function applyHour(hour) {
    const night = hour >= NIGHT_HOUR;
    const p = smoothstep((hour - BLEND_START) / (BLEND_END - BLEND_START));
    const pFg = night ? 1 : 0;
    for (const k in THEME_DAY) {
      const prog = FG_KEYS.includes(k) ? pFg : p;
      document.body.style.setProperty(k, lerpColor(THEME_DAY[k], THEME_NIGHT[k], prog));
    }

    document.body.classList.toggle('low', night);

    const video = document.querySelector('.intro__video');
    if (video) {
      const src = night ? video.dataset.nightSrc : video.dataset.daySrc;
      const poster = night ? video.dataset.nightPoster : video.dataset.dayPoster;
      if (src && !video.src.endsWith(src)) {
        video.poster = poster || '';
        video.src = src;
      }
    }

    if (night !== applyHour._night) {
      applyHour._night = night;
      reorderAlbums(night);
      highlightTracklist();
    }
  }

  // journee -> plein jour, soiree -> fondu, nuit -> noir, aube -> fondu inverse
  function hourToThemeHour(h) {
    if (h >= 18) return Math.min(h, 24);
    if (h >= 7) return 18;
    if (h >= 5) return 24 - ((h - 5) / 2) * 6;
    return 24;
  }

  function setupClock() {
    const box = document.getElementById('clockbox');
    if (!box) return;
    const dayDuration = Number(box.dataset.dayDuration) || 60;
    const handH = document.getElementById('clock-h');
    const handM = document.getElementById('clock-m');

    const face = document.getElementById('clock-face');
    for (let n = 0; n < 12; n++) {
      const tick = document.createElement('span');
      tick.className = 'clock-tick';
      tick.style.transform = `rotate(${n * 30}deg) translateY(-61px)`;
      face.appendChild(tick);

      const num = document.createElement('span');
      num.className = 'clock-num';
      num.textContent = n === 0 ? 12 : n;
      num.style.transform = `rotate(${n * 30}deg) translateY(-46px) rotate(${-n * 30}deg)`;
      face.appendChild(num);
    }

    // indicateur AM/PM : leve l'ambiguite du cadran 12h
    const ampm = document.createElement('span');
    ampm.className = 'clock-ampm';
    face.appendChild(ampm);

    const now = new Date();
    const startHour = now.getHours() + now.getMinutes() / 60;
    const t0 = performance.now();

    function tick(ts) {
      const virtualHour = (startHour + ((ts - t0) / 1000) * (24 / dayDuration)) % 24;

      handH.style.transform = `rotate(${(virtualHour % 12) / 12 * 360}deg)`;
      handM.style.transform = `rotate(${(virtualHour % 1) * 360}deg)`;
      ampm.textContent = virtualHour >= 12 ? 'PM' : 'AM';

      // theme recalcule a chaque frame -> fondu jour/nuit parfaitement lisse
      applyHour(hourToThemeHour(virtualHour));
      requestAnimationFrame(tick);
    }

    applyHour(hourToThemeHour(startHour));
    requestAnimationFrame(tick);
    requestAnimationFrame(() => document.body.classList.add('theme-ready'));
  }

  setupClock();

  /* ============================================================
     TOUR DATES via l'API Seated, rendues dans la table document
     (meme format que la version locale). Repli : widget officiel.
     ============================================================ */

  (async function setupSeatedTour() {
    const table = document.getElementById('tour-table');
    if (!table || !table.dataset.seatedArtist) return;
    const tbody = document.getElementById('tour-list');
    const artistId = table.dataset.seatedArtist;

    try {
      const res = await fetch('https://cdn.seated.com/api/tour/' + artistId + '?include=tour-events');
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();

      let events = [];
      if (data.included) {
        events = data.data.relationships['tour-events'].data
          .map(ref => data.included.find(x => x.id === ref.id && x.type === 'tour-events'))
          .filter(Boolean);
      }

      if (!events.length) {
        tbody.innerHTML = '<tr><td colspan="4" class="doc-table__info">No upcoming dates.</td></tr>';
        return;
      }

      const esc = s => String(s || '').replace(/[&<>"]/g,
        c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

      tbody.innerHTML = events.map(ev => {
        const a = ev.attributes;
        const soldout = a['is-sold-out'];
        const date = a['starts-at-date-local'] || a['starts-at-short'] || '';
        return '<tr' + (soldout ? ' class="is-soldout"' : '') + '>' +
          '<td>' + esc(date) + '</td>' +
          '<td>' + esc(a['formatted-address']) + '</td>' +
          '<td>' + esc(a['venue-name']) + '</td>' +
          '<td>' + (soldout
            ? 'Sold out'
            : '<a href="https://link.seated.com/' + esc(ev.id) + '" target="_blank" rel="noopener">[Tickets]</a>') +
          '</td></tr>';
      }).join('');
    } catch (e) {
      // API indisponible : on remet le widget officiel Seated
      table.style.display = 'none';
      const holder = document.getElementById('seated-fallback');
      if (!holder) return;
      const div = document.createElement('div');
      div.id = 'seated-55fdf2c0';
      div.dataset.artistId = artistId;
      div.dataset.cssVersion = '3';
      holder.appendChild(div);
      const s = document.createElement('script');
      s.src = 'https://widget.seated.com/app.js';
      holder.appendChild(s);
    }
  })();

  /* ============================================================
     4. MODE SOON (compte a rebours avant lancement)
     Active via Reglages du theme -> Lancement. L'horloge est
     deplacee dans l'ecran soon ; a T-0 le site apparait.
     ============================================================ */

  (function setupSoon() {
    const overlay = document.getElementById('soon');
    if (!overlay) return;
    const target = new Date(overlay.dataset.launch).getTime();
    if (isNaN(target) || Date.now() >= target) return;

    const clock = document.getElementById('clockbox');
    const homeSlot = clock ? clock.parentNode : null;
    const soonSlot = document.getElementById('soon-clock-slot');
    if (clock && soonSlot) soonSlot.appendChild(clock);

    overlay.hidden = false;
    document.body.classList.add('soon-active');

    const count = document.getElementById('soon-count');
    let iv;

    function tick() {
      const left = target - Date.now();
      if (left <= 0) {
        clearInterval(iv);
        document.body.classList.remove('soon-active');
        overlay.hidden = true;
        if (clock && homeSlot) homeSlot.appendChild(clock);
        return;
      }
      const s = Math.floor(left / 1000);
      const d = Math.floor(s / 86400);
      const h = Math.floor(s % 86400 / 3600);
      const m = Math.floor(s % 3600 / 60);
      const sec = s % 60;
      count.textContent = `T-MINUS ${d}D ${String(h).padStart(2, '0')}H ${String(m).padStart(2, '0')}M ${String(sec).padStart(2, '0')}S`;
    }

    tick();
    iv = setInterval(tick, 1000);
  })();
});
